import styled from "styled-components";

function ItemsList({ list }) {
  return (
    <List>
      {list.map((item, index) => (
        <ListItem  key={index}>
          <Dot />
          <Text>
            {item}
          </Text>
        </ListItem>
      ))}
    </List>
  )
}

export default function MayoCareItem({image, imageSize, title, items}) {
  return (
    <Container>
      <Image 
        src={image}
        width={imageSize?.width}
        height={imageSize?.height}
      />
      <Title>
        {title}
      </Title>
      <SubContainer>
        { items &&
          items.map((item, index) => {
            if(Array.isArray(item)) {
              return <ItemsList key={index} list={item} />
            }
            else {
              return <Text key={index}>
                {item}
              </Text>
            }
          })
        }
      </SubContainer>
    </Container>
  );
}

const Container = styled.div`
  margin-inline: 26px;
`

const Image = styled.img`
  display: block;
`

const Title = styled.p`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  margin-top: 29px;
  margin-bottom: 24px;
`

const Text = styled.p`
  margin: 0;
  font-size: 19px;
`

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
`

const List = styled.ul`
  margin: 0;
  padding: 0;
  gap: 2px;
`

const ListItem = styled.li`
  display: flex;
  gap: 14px;
`

const Dot = styled.div`
  width: 11px;
  height: 11px;
  background-color: #83A4FC;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 6px;
`